// extracted by mini-css-extract-plugin
export default {"cloth":"laundryCard_cloth__mp1lb","laundryCard":"laundryCard_laundryCard__iz7Co","addButtonWrapper":"laundryCard_addButtonWrapper__hEbLp"};